// cometdService.js
import cometdLib from "cometd";
import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";

let cometd;
let isConnected = false;
let subscription;
let recieveURLGlobal;
let listOfComponentsToUpdate;
let refElementGlobal;
let storedD = null;
const storeCometd =(redd)=>{
  const cometDString = JSON.stringify(redd, (key, value) => {
    if (typeof value === 'function') {
        return value.toString();
    }
    return value;
});
 
sessionStorage.setItem('cometd',cometDString)
storedD =JSON.parse(cometDString)
}
//enabling reload
// window.addEventListener("beforeunload", () => {
//   cometd.reload();
// })
// Standalone handshake function
const handshakeCometD = (additional, appComponent, refElement) => {
  cometd.handshake(additional, function (handshakeReply) {
    if (handshakeReply.successful) {
      console.log("COMETD-LOG: HANDSHAKE SUCCESSFUL", handshakeReply, refElement);
      sessionStorage.setItem('cometdClientId', cometd.getClientId());
      subscribeToChannel(refElement);
      isConnected = true;
    } else {
      console.error("COMETD-LOG: HANDSHAKE FAILED", handshakeReply);
      sessionStorage.removeItem('cometdClientId');
      appComponent?.actions?.handleShowReloadPopup();
    }
  });
};

// Subscription function
const subscribeToChannel = (refElement) => {
  cometd.batch(function () {
    cometd.subscribe(
      recieveURLGlobal,
      function (message) {
        if (message) {
          console.log("COMETD-LOG: EVENT TRIGGERED", message);
          let customEvent = new CustomEvent("updateComponent", {
            detail: {
              componentsToUpdate: listOfComponentsToUpdate,
              data: {
                message,
              },
            },
            bubbles: true,
          });
          console.log("subscribed from cometd");
          refElement.current.dispatchEvent(customEvent);
        }
      },
      function (ack) {
        if (ack.successful) {
          console.log("COMETD-LOG: RECEIVE CHANNEL SUBSCRIBED", refElement);
        }
      }
    );
  });
};

// Main CometD service function
export const CometdDService = (refElement, listenChannel, appComponent) => {
  refElementGlobal = refElement;
  cometd = new cometdLib.CometD();
  storeCometd(cometd);
  listOfComponentsToUpdate = ["ConversationPage", "LandingPage"];

  const host = s360ConfigService.config.host;
  const connectionURL = `https://${host}/bmcometd/cometd`;
  const recieveURL = `/${listenChannel}`;
  recieveURLGlobal = recieveURL;

  const secureCometdToken = localStorage.getItem("cometdToken");
  const secureCometdUser = localStorage.getItem("cometdUser");
  const additional = {
    ext: {
      "com.inrev.authn": {
        user: secureCometdUser || "cometuser1",
        token: secureCometdToken || "adfwew283292"
      }
    },
  };

  cometd.websocketEnabled = true;
  cometd.configure({ url: connectionURL.trim() });

  const storedClientId = sessionStorage.getItem('cometdClientId');
  if (storedClientId === null) {
    handshakeCometD(additional, appComponent, refElement);
  } else {
    const additionalWithClientId = {
      ext: {
        clientID: storedClientId,
        
        "com.inrev.authn": {
          user: secureCometdUser || "cometuser1",
          token: secureCometdToken || "adfwew283292"
        }
      },
    };
    console.log(typeof(storedD), storedD.handshake)
    if( typeof(storedD)==='object'){
      cometd.handshake(additionalWithClientId, (handshakeReply) => {
        if (handshakeReply.successful) {
          console.log('Reusing stored client ID', storedClientId, handshakeReply);
          subscribeToChannel(refElement);
          isConnected = true;
        } else {
          console.error('Stored client ID invalid, performing new handshake', handshakeReply);
          sessionStorage.removeItem('cometdClientId');
          handshakeCometD(additional, appComponent, refElement);
        }
      });
    }
    else{
      cometd.handshake(additionalWithClientId, (handshakeReply) => {
        if (handshakeReply.successful) {
          console.log('Reusing stored client ID', storedClientId, handshakeReply);
          subscribeToChannel(refElement);
          isConnected = true;
        } else {
          console.error('Stored client ID invalid, performing new handshake', handshakeReply);
          sessionStorage.removeItem('cometdClientId');
          handshakeCometD(additional, appComponent, refElement);
        }
      });
    }
    
  }
};

// Connection lost listener functions
const onConnectionLost = () => {
  console.log("Connection Lost");
  isConnected = false;
};

export const addConnectionLostListener = () => {
  console.log("CONNECTION LOST RETRYING..");
  cometd.addListener('/meta/connect', onConnectionLost);
};

export const removeConnectionLostListener = () => {
  console.log("CONNECTION ESTABLISHED");
  cometd.removeListener('/meta/connect', onConnectionLost);
};

export const reConnectCometd = () => {
  console.log("TRYING TO RECONNECT");
  if (subscription) cometd.unsubscribe(subscription);
  subscribeToChannel(refElementGlobal);
};
